import { COLORS } from 'constants/index';

export default {
    root: {
        color: COLORS.apariBlack80,
        fontSize: 13,
        borderRadius: '2px !important'
    }
};
